export const Appointment = "/Appointments";
export const Edit_Appointment = "/Appointments/edit/:id";
export const AppointmentReport = "/Appointments/report";